const CustomerIdType =
    [
        'Carte Nationale d\'Identité(CNI)',
        'Permis de conduire',
        'Passeport',
        'Attestation d\'identité',
        'Carte consulaire'
    ]
export default CustomerIdType